import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    /** HttpClient sem interceptors — evita ciclo HTTP_INTERCEPTORS ↔ Transloco. */
    private readonly http: HttpClient;

    constructor(httpBackend: HttpBackend) {
        this.http = new HttpClient(httpBackend);
    }

    /**
     * Quando há escopo (ex: provideTranslocoScope('auth')), o Transloco chama com
     * lang = "scope/lang" (ex: "auth/pt-BR"). Sem escopo, lang = "pt-BR".
     * Em ambos os casos a URL é /assets/i18n/{lang}.json (ex: auth/pt-BR → auth/pt-BR.json).
     */
    getTranslation(lang: string): Observable<Translation> {
        return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
    }
}
